export const REQUIREMENT_STYLE = {
  satisfied: "bg-emerald-50 text-emerald-700",
  potentially_satisfied: "bg-sky-50 text-sky-700",
  evidence_required: "bg-amber-50 text-amber-700",
  assessment_available: "bg-cobalt/10 text-cobalt",
  alternative_route: "bg-violet-50 text-violet-700",
  provider_confirmation_required: "bg-amber-50 text-amber-700",
  official_verification_required: "bg-amber-100 text-amber-800",
  missing: "bg-amber-50 text-amber-700",
  needs_verification: "bg-amber-50 text-amber-700",
  needs_review: "bg-slate-100 text-slate-700",
  not_met: "bg-rose-50 text-rose-700",
  not_required: "bg-slate-100 text-slate-600",
};

export const OVERALL_LABEL = {
  likely_eligible_indicative: "Likely eligible (indicative)",
  assessment_complete_verification_required: "Assessment complete — verification required",
  route_available: "Route available",
  not_currently_eligible: "Not currently eligible through the standard route",
};

export const statusLabel = (value) => (value || "unknown").replaceAll("_", " ");

export const ResultPill = ({ status }) => (
  <span className={`rounded-full px-3 py-1 text-xs font-bold capitalize ${REQUIREMENT_STYLE[status] || REQUIREMENT_STYLE.needs_review}`}>{statusLabel(status)}</span>
);
